/**
 * @generated SignedSource<<37fd70250cf323faed8eaab1c7b77e6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type categoryFilter_softwareReleasesVersionRelatedWork$data = ReadonlyArray<{
  readonly node: {
    readonly category: string;
  };
  readonly " $fragmentType": "categoryFilter_softwareReleasesVersionRelatedWork";
} | null | undefined>;
export type categoryFilter_softwareReleasesVersionRelatedWork$key = ReadonlyArray<{
  readonly " $data"?: categoryFilter_softwareReleasesVersionRelatedWork$data;
  readonly " $fragmentSpreads": FragmentRefs<"categoryFilter_softwareReleasesVersionRelatedWork">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "categoryFilter_softwareReleasesVersionRelatedWork",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "category"
            },
            "action": "NONE",
            "path": "node.category"
          }
        ]
      },
      "action": "NONE",
      "path": "node"
    }
  ],
  "type": "JiraVersionRelatedWorkV2Edge"
};

(node as any).hash = "26b1d568eba141b6bfe3000d32fec7e5";

export default node;
